const MIMES = {
  PDF: 'application/pdf',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
};

const KEYS = {
  EXTENSIONS: 'extensions',
  HEADERS: 'headers',
};

const MIMES_MAP = {
  [MIMES.PDF]: {
    [KEYS.EXTENSIONS]: 'pdf',
    [KEYS.HEADERS]: '25504446',
  },
  [MIMES.JPEG]: {
    [KEYS.EXTENSIONS]: ['jpg', 'jpeg'],
    [KEYS.HEADERS]: [
      'ffd8ffe0',
      'ffd8ffe1',
      'ffd8ffe2',
      'ffd8ffe3',
      'ffd8ffe8',
      'ffd8ffe9',
      'ffd8ffdb',
      'ffd8ffed',
    ],
  },
  [MIMES.PNG]: {
    [KEYS.EXTENSIONS]: 'png',
    [KEYS.HEADERS]: '89504e47',
  },
};

const EXPORT_FORMATS = Object.freeze({
  STRING: 'STRING',
  ARRAY: 'ARRAY',
});

function getValues(mime, key) {
  const value = MIMES_MAP?.[mime]?.[key];

  if (!value) {
    return null;
  }

  return value;
}

function getEntities(mimes, key) {
  if (!Array.isArray(mimes)) {
    throw new TypeError('Array expected');
  }

  return mimes.map(mime => getValues(mime, key)).flat();
}

function getExtensionsByMimes(mimes, exportType = EXPORT_FORMATS.STRING) {
  const res = getEntities(mimes, KEYS.EXTENSIONS).map(extension => `.${extension}`);

  return exportType === EXPORT_FORMATS.STRING ? res.join(',') : res;
}

function getHeadersByMimes(mimes, exportType = EXPORT_FORMATS.STRING) {
  const res = getEntities(mimes, KEYS.HEADERS);

  return exportType === EXPORT_FORMATS.STRING ? res.join(',') : res;
}

export { getExtensionsByMimes, getHeadersByMimes, EXPORT_FORMATS };
